import React, { useEffect, useMemo } from 'react';
import ReactWebChat, { createDirectLine, createStyleSet } from 'botframework-webchat';

import './WebChat.css';

const WebChat = ({ className, onFetchToken, store, token }) => {
  const directLine = useMemo(() => createDirectLine({ token }), [token]);
  const adaptiveCardHostConfig = {
    "actions": {
      // "maxActions": 100,
      // "spacing": "Default",
      // "buttonSpacing": 8,
      // "showCard": {
      //   "actionMode": "Inline",
      //   "inlineTopMargin": 20,
      //   "style": "emphasis",
      //   "fontSize": "small"
      // },
      "preExpandSingleShowCardAction": true,
      "actionsOrientation": "default",
      "actionAlignment": "Stretch",
      "wrap": true
      //"iconPlacement": "aboveTitle"
 
    },
    "containerStyles": {
      "default": {
        "foregroundColors": {
          "default": {
            "default": "#000000",
            "subtle": "#767676",
            "highlightColors": {
              "default": "#22000000",
              "subtle": "#11000000"
            }
          },
          "dark": {
            "default": "#000000",
            "subtle": "#66000000",
            "highlightColors": {
              "default": "#22000000",
              "subtle": "#11000000"
            }
          },
          "light": {
            "default": "#FFFFFF",
            "subtle": "#33000000",
            "highlightColors": {
              "default": "#22000000",
              "subtle": "#11000000"
            }
          },
          "accent": {
            "default": "#6264a7",
            "subtle": "#6264a7",
            "highlightColors": {
              "default": "#22000000",
              "subtle": "#11000000"
            }
          },
          "good": {
            "default": "#54a254",
            "subtle": "#DD54a254",
            "highlightColors": {
              "default": "#22000000",
              "subtle": "#11000000"
            }
          },
          "warning": {
            "default": "#c3ab23",
            "subtle": "#DDc3ab23",
            "highlightColors": {
              "default": "#22000000",
              "subtle": "#11000000"
            }
          },
          "attention": {
            "default": "#FF0000",
            "subtle": "#DDFF0000",
            "highlightColors": {
              "default": "#22000000",
              "subtle": "#11000000"
            }
          }
        },
        "backgroundColor": "#FFFFFF"
      },
    }
  };
  const styleSet = useMemo(
    () =>
      createStyleSet({
        backgroundColor: 'Transparent',
        suggestedActionHeight: 35,
        suggestedActionBorderWidth: 1,
        suggestedActionBorderRadius: 5,
        suggestedActionTextColor: '#39C',
        avatarSize: 23,
        bubbleFromUserBackground:'#464774',
        bubbleFromUserTextColor:'white',
        backgroundColor: '#EEE9E9'
      }),
    []
  );
  const styleOptions = {
    rootwidth: 'Auto',
    botAvatarImage: 'https://isgchatbot.azure-api.net/V1-clone/getImages?status=color',
    botAvatarInitials: '',
    userAvatarImage: 'https://isgchatbot.azure-api.net/V1-clone/getImages',
    userAvatarInitials: '',
    };
  useEffect(() => {
    onFetchToken();
  }, [onFetchToken]);

  return token ? (
    <ReactWebChat className={`${className || ''} web-chat`}
      adaptiveCardHostConfig={adaptiveCardHostConfig}
      directLine={directLine} store={store} styleSet={styleSet} styleOptions={styleOptions}/>
  ) : (
    <div className={`${className || ''} connect-spinner`}>
      <div className="content">
        <div className="icon">
          <img src="https://isgchatbot.azure-api.net/V1-clone/getImages?status=color" width="50px" height="50px"></img>
        </div>
        <p>Please wait while we are connecting.</p>
      </div>
    </div>
  );
};

export default WebChat;
